module.exports = __webpack_public_path__ + "img/card-1.73d8713e.png";